// extracted by mini-css-extract-plugin
export default {"button":"GenerateReport_button__Z84rv","clock":"GenerateReport_clock__IjoZw","notOpenText":"GenerateReport_notOpenText__Kzkoe"};